var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 10.96,
    y: 4.14,
    width: 3.56,
    height: 16.93,
    transform: "translate(12.65 -5.32) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 30.95,
    y: 19.25,
    width: 3.56,
    height: 20.97,
    transform: "translate(30.61 -14.43) rotate(45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 18.44,
    y: 17.77,
    width: 3.56,
    height: 11.83,
    transform: "translate(22.67 -7.36) rotate(45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 24.74,
    y: 18.39,
    width: 3.56,
    height: 16.54,
    transform: "translate(26.62 -10.95) rotate(45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 14.28,
    y: 11.98,
    width: 3.56,
    height: 13.18,
    transform: "translate(17.84 -5.91) rotate(45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "40.66 28.56 42.5 42.64 28.69 40.53 40.66 28.56"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.92,
    y1: 41.92,
    x2: 41.78,
    y2: 38.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyPlus);
export default __webpack_public_path__ + "static/media/StudyPlus.46d61b7922987f030e6c096d5ca24cfb.svg";
export { ForwardRef as ReactComponent };